/**
 * Description:
 * 1. Mục đích: code các luồng liên quan đến dữ liệu về tài khoản
 */
import { useAppSelector } from '@/stores/dataStore/reduxStore/hook';
import { ResponseSuccess } from '../followerTransManager/followerTransManager';
import inqService from '@/stores/dataManager/apiServices/inqService';
import ToastUtil from '@/views/components/Toast/Toast';
import i18next from 'i18next';
import authService from '@/stores/dataManager/apiServices/authService';

export const useAccounts = () => {
    try {
        const accounts = useAppSelector((state) => state.app.accounts)
        return {
            accounts
        };
    } catch (e) {
        return {
            accounts: [],
        };
    }
}

export const useUserInfo = () => {
    try {
        const userInfo = useAppSelector((state) => state.app.userInfo)
        return {
            userInfo
        };
    } catch (e) {
        return {
            userInfo: {},
        };
    }
}

export const useCosInfo = () => {
    try {
        const cosInfo = useAppSelector((state) => state.app.cosInfo)
        return {
            cosInfo
        };
    } catch (e) {
        return {
            cosInfo: {},
        };
    }
}

export const getDataRoleAccount = async (custodycd: string) => {
    const param = {
        config: {},
        custodycd
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getRoleByAccount(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data[0]
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getDataRoleAccount'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export type VerifyData = {
    "tokenid": string | null,
    "transactionId": string,
    "authtypes": string[],
    "authtype": string,
    "challengeQuestion": string | null,
    "verified": boolean,
}

export const InitVerifyData = {
    authtype: '',
    authtypes: [],
    challengeQuestion: '',
    tokenid: '',
    transactionId: '',
    verified: false
}

export const doInit2factorAuth = async () => {
    const param = {
        config: {},
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await authService.init2FactorAuth(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getDataRoleAccount'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const doResendOTP = async ({ transactionId, authtype }: { transactionId: string, authtype: string }) => {
    const param = {
        config: {},
        body: {
            transactionId,
            authtype
        }
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await authService.resendOTP(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getDataRoleAccount'))
        result = {
            isSuccess: false,
        }
    })
    return result
}
